
import { Component, Vue } from "vue-property-decorator";
import SubclientsTable from "@/components/subclient/SubclientsTable.vue";

@Component({
  name: "subclients-page",
  components: { SubclientsTable },
})
export default class SubclientsPage extends Vue {
  constructor() {
    super();
  }

  goToAddSubclient = async (): Promise<void> => {
    await this.$router.push({
      name: "add-subclient",
    });
  };
}
